import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.string.includes.js";
import "core-js/modules/es7.array.includes.js";
import hotkeys from 'hotkeys-js';
import { useCallback, useEffect } from 'react';
function useHotkeys(keys, callback, options, deps) {
  if (options instanceof Array) {
    deps = options;
    options = undefined;
  }
  var _ref = options || {},
    enableOnTags = _ref.enableOnTags,
    filter = _ref.filter;
  var memoisedCallback = useCallback(callback, deps || []);
  useEffect(function () {
    if (options && options.enableOnTags) {
      hotkeys.filter = function (_ref2) {
        var target = _ref2.target,
          srcElement = _ref2.srcElement;
        // @ts-ignore
        var targetTagName = target && target.tagName || srcElement && srcElement.tagName;
        return Boolean(targetTagName && enableOnTags && enableOnTags.includes(targetTagName));
      };
    }
    if (filter) hotkeys.filter = filter;
    hotkeys(keys, options || {}, memoisedCallback);
    return function () {
      return hotkeys.unbind(keys, memoisedCallback);
    };
  }, [memoisedCallback, options]);
}
export { useHotkeys };